"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTool = void 0;
const geojson_1 = require("../../geojson");
const turf_1 = require("@turf/turf");
class BaseTool {
    constructor() {
        /**
         * Returns the geometry collection from feature collection
         */
        this.getGeometryCollection = (featureCollection) => {
            return {
                type: "GeometryCollection",
                geometries: featureCollection.features.map((feature) => {
                    feature.geometry.id = feature.id;
                    return feature.geometry;
                }),
            };
        };
        /**
         * Returns the FeatureCollection from geometry array
         */
        this.getFeatureCollection = (geometries) => {
            //convert multipolygons to individual polygons
            const result = geometries
                .filter((geometry) => geometry.type === "MultiPolygon" || geometry.type === "Polygon")
                .reduce((acc, geometry) => {
                return acc.concat(geojson_1.GeoJsonUtils.multiPolygonToPolygons(geometry));
            }, [])
                .map((polygon) => (0, turf_1.feature)(polygon));
            return (0, turf_1.featureCollection)(result);
        };
    }
}
exports.BaseTool = BaseTool;
